'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _PlayerCache2 = require('./PlayerCache');

var _PlayerCache3 = _interopRequireDefault(_PlayerCache2);

var _LiveSeekPlayer = require('./wrappers/LiveSeekPlayer');

var _LiveSeekPlayer2 = _interopRequireDefault(_LiveSeekPlayer);

var _InstreamAdPlayer = require('./wrappers/InstreamAdPlayer');

var _InstreamAdPlayer2 = _interopRequireDefault(_InstreamAdPlayer);

var _players = require('./constants/players');

var _players2 = _interopRequireDefault(_players);

var _mediaFormats = require('./constants/mediaFormats');

var _mediaFormats2 = _interopRequireDefault(_mediaFormats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-underscore-dangle */
var PlayerLoader = function (_PlayerCache) {
  (0, _inherits3.default)(PlayerLoader, _PlayerCache);

  function PlayerLoader(configuration) {
    (0, _classCallCheck3.default)(this, PlayerLoader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlayerLoader.__proto__ || (0, _getPrototypeOf2.default)(PlayerLoader)).call(this, configuration));

    _this.configuration = configuration;
    return _this;
  }

  /**
   * Public method that returns an array of player instances for the
   * given stream.
   *
   * @param stream {Object}
   * @returns {Promise<any[]>}
   */


  (0, _createClass3.default)(PlayerLoader, [{
    key: 'getPlayers',
    value: function getPlayers(stream) {
      var playerPromises = [this._getInstreamAdPlayer(stream), this._getLiveSeekPlayer(stream),
      // Must try HLS.js player first otherwise Safari will always choose native implementation.
      this._getHlsJsPlayer(stream), this._getHowler(), this._getJPlayer(), this._getWindowsMediaPlayer()].map(function (promise) {
        return promise && promise.catch(_noop2.default);
      });

      return _promise2.default.all(playerPromises).then(function (loadedPlayers) {
        return loadedPlayers.filter(Boolean);
      });
    }
  }, {
    key: '_getInstreamAdPlayer',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(stream) {
        var hlsjsPlayer, _configuration, timeout, isInstreamLoggingEnabled, tuner;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (stream.isHlsAdvanced) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', null);

              case 2:
                _context.next = 4;
                return this._getPlayerFromCache(_players2.default.hlsjs);

              case 4:
                hlsjsPlayer = _context.sent;

                if (hlsjsPlayer) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', null);

              case 7:
                _configuration = this.configuration, timeout = _configuration.timeout, isInstreamLoggingEnabled = _configuration.isInstreamLoggingEnabled, tuner = _configuration.tuner;
                return _context.abrupt('return', new _InstreamAdPlayer2.default(hlsjsPlayer, timeout, isInstreamLoggingEnabled, tuner));

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _getInstreamAdPlayer(_x) {
        return _ref.apply(this, arguments);
      }

      return _getInstreamAdPlayer;
    }()
  }, {
    key: '_getLiveSeekPlayer',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(stream) {
        var hlsjsPlayer;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (stream.isLiveSeekStream) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', null);

              case 2:
                _context2.next = 4;
                return this._getPlayerFromCache(_players2.default.hlsjs);

              case 4:
                hlsjsPlayer = _context2.sent;

                if (hlsjsPlayer) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', null);

              case 7:
                return _context2.abrupt('return', new _LiveSeekPlayer2.default(hlsjsPlayer));

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _getLiveSeekPlayer(_x2) {
        return _ref2.apply(this, arguments);
      }

      return _getLiveSeekPlayer;
    }()
  }, {
    key: '_getHowler',
    value: function _getHowler() {
      if (this.configuration.isHowlerEnabled) {
        return this._getPlayerFromCache(_players2.default.howler);
      }
    }
  }, {
    key: '_getJPlayer',
    value: function _getJPlayer() {
      return this._getPlayerFromCache(_players2.default.jplayer);
    }
  }, {
    key: '_getHlsJsPlayer',
    value: function _getHlsJsPlayer(stream) {
      if (stream.format === _mediaFormats2.default.hls && !this.configuration.hasNativeHlsSupport) {
        return this._getPlayerFromCache(_players2.default.hlsjs);
      }
    }
  }, {
    key: '_getWindowsMediaPlayer',
    value: function _getWindowsMediaPlayer() {
      return this._getPlayerFromCache(_players2.default.wmp);
    }
  }, {
    key: '_getPlayerFromCache',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(playerName) {
        var player;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getPlayer(playerName);

              case 2:
                player = _context3.sent;

                this.setPlayer(playerName);
                return _context3.abrupt('return', player);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _getPlayerFromCache(_x3) {
        return _ref3.apply(this, arguments);
      }

      return _getPlayerFromCache;
    }()
  }]);
  return PlayerLoader;
}(_PlayerCache3.default);

exports.default = PlayerLoader;
//# sourceMappingURL=PlayerLoader.js.map